/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-down': {
    width: 10,
    height: 6,
    viewBox: '0 0 10 6',
    data: '<path pid="0" opacity=".6" d="M8.293.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4A1 1 0 011.707.293L5 3.586 8.293.293z" _fill="#000" fill-opacity=".8"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/arrow-down.js